import { action } from 'easy-peasy';
import { IActionStartCrisisVisit } from '../types';
import { matchesAllocation, recalculateCrisisStatus } from './helpers';

const startCrisisVisit: IActionStartCrisisVisit = action(
  (state, { userId, clientId, crisisCallId, startTimeUtc }) => {
    if (!crisisCallId) {
      // Ad-hoc visit (no allocation): only flag the team member, no visitStartTime to set
      const teamMember = state.crisisCallTeamMembers.find(member => member.id === userId);

      if (!teamMember) {
        return;
      }

      teamMember.hasNoAllocationActiveVisit = true;
      recalculateCrisisStatus(teamMember);
      return;
    }

    if (!startTimeUtc) {
      return;
    }

    state.crisisCallTeamMembers.forEach(teamMember => {
      let wasUpdated = false;

      teamMember.allocatedClients.forEach(allocation => {
        const canOverwriteVisitStartTime = teamMember.id === userId || !allocation.visitStartTime;

        if (matchesAllocation(allocation, clientId, crisisCallId) && canOverwriteVisitStartTime) {
          allocation.visitStartTime = startTimeUtc;
          wasUpdated = true;
        }
      });

      if (wasUpdated) {
        recalculateCrisisStatus(teamMember);
      }
    });
  },
);

export default startCrisisVisit;
